/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UpsertStorageBindingInstanceRequest
 */
export interface UpsertStorageBindingInstanceRequest {
    /**
     * 
     * @type {string}
     * @memberof UpsertStorageBindingInstanceRequest
     */
    purpose?: UpsertStorageBindingInstanceRequestPurposeEnum;
    /**
     * 
     * @type {string}
     * @memberof UpsertStorageBindingInstanceRequest
     */
    storageAccountId?: string;
}


/**
 * @export
 */
export const UpsertStorageBindingInstanceRequestPurposeEnum = {
    IntegrationPipeline: 'INTEGRATION_PIPELINE',
    SecureFiles: 'SECURE_FILES'
} as const;
export type UpsertStorageBindingInstanceRequestPurposeEnum = typeof UpsertStorageBindingInstanceRequestPurposeEnum[keyof typeof UpsertStorageBindingInstanceRequestPurposeEnum];


/**
 * Check if a given object implements the UpsertStorageBindingInstanceRequest interface.
 */
export function instanceOfUpsertStorageBindingInstanceRequest(value: object): value is UpsertStorageBindingInstanceRequest {
    return true;
}

export function UpsertStorageBindingInstanceRequestFromJSON(json: any): UpsertStorageBindingInstanceRequest {
    return UpsertStorageBindingInstanceRequestFromJSONTyped(json, false);
}

export function UpsertStorageBindingInstanceRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpsertStorageBindingInstanceRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'purpose': json['purpose'] == null ? undefined : json['purpose'],
        'storageAccountId': json['storageAccountId'] == null ? undefined : json['storageAccountId'],
    };
}

export function UpsertStorageBindingInstanceRequestToJSON(json: any): UpsertStorageBindingInstanceRequest {
    return UpsertStorageBindingInstanceRequestToJSONTyped(json, false);
}

export function UpsertStorageBindingInstanceRequestToJSONTyped(value?: UpsertStorageBindingInstanceRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'purpose': value['purpose'],
        'storageAccountId': value['storageAccountId'],
    };
}

